module.exports = __webpack_public_path__ + "img/2243219-80-7.a11f73f5.png";